// googleLogin.js
import { signInWithPopup, signInWithRedirect } from "firebase/auth";
import { auth, googleProvider } from "./index";

export const loginWithGoogle = async () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // await signInWithRedirect(auth, googleProvider);
    // return null;
    
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } else {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  }
};
